import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';

import {
  Container,
  MainContainer,
  InfoContainer,
  Paper,
  CouponRate,
  Volume,
  InfoRow,
  InfoName,
  InfoValue,
  CouponRateWrapper,
  MainWrapper,
} from './styles';

export const propTypes = {
  paper: PropTypes.string.isRequired,
  volume: PropTypes.string.isRequired,
  couponRate: PropTypes.shape({
    prefix: PropTypes.string,
    value: PropTypes.string.isRequired,
  }),
  button: PropTypes.shape({
    name: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }),
  info: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ),
};

const downloadClick = (link) => window.open(link, '_blank');

const renderInfo = ({ name, value }, i) => (
  <InfoRow key={i}>
    <InfoName>{name}</InfoName>
    <InfoValue>{value}</InfoValue>
  </InfoRow>
);

const Stock = ({
  paper, couponRate, volume, info, button, index,
}) => {
  const isFirst = index === 0;

  return (
    <Container isFirst={isFirst}>
      <MainContainer>
        <MainWrapper>
          <Paper>{paper}</Paper>
          <CouponRateWrapper>
            {!!couponRate.prefix && <CouponRate isPrefix>{couponRate.prefix}</CouponRate>}
            <CouponRate>{couponRate.value}</CouponRate>
          </CouponRateWrapper>
          <Volume>{volume}</Volume>
        </MainWrapper>
        {button
      && (
      <Button onClick={() => downloadClick(button.link)} className="StockButton" small>
        {button.name}
      </Button>
      )}
      </MainContainer>
      <InfoContainer>
        {info.map(renderInfo)}
      </InfoContainer>
    </Container>
  );
};

Stock.propTypes = {
  ...propTypes,
};

export default Stock;
